import { rootApi } from "..";
import { centerListService } from "../../../Api/Services/CenterListService/CenterListService";
import { dashboardService } from "../../../Api/Services/DashboardService";
import { departmentService } from "../../../Api/Services/DepartmentService";
import { employeeDetailService } from "../../../Api/Services/EmployeeDetailsService/EmplooyeeDetailsService";
import { misDownloadService } from "../../../Api/Services/MISDownloadService";
import { makeEndpoints } from "../../../utils/rtkQueryFactory";

export const organizationMasterEndpoints = [
  {
    name: "getCentersList",
    type: "query",
    serviceFn: () => centerListService.getAllCenters(),
  },
  {
    name: "getDepartmentList",
    type: "query",
    serviceFn: ({ status = "active" }) =>
      departmentService.getAllDepartment(status),
  },
  {
    name: "getSubDepartmentList",
    type: "query",
    serviceFn: ({ id }: { id: number }) =>
      departmentService.getSubDepartments(id),
  },
  {
    name: "getEmployeeRolesTypeList",
    type: "query",
    serviceFn: () => employeeDetailService.getEmployeeTypes(),
  },
  {
    name: "getEmployeeJobTypesList",
    type: "query",
    serviceFn: () => employeeDetailService.getEmployeeJobTypesList(),
  },
  {
    name: "getMisDownloadDetails",
    type: "query",
    serviceFn: ({ folderId }: { folderId?: string }) =>
      misDownloadService.getMisDownloads(folderId),
  },
  {
    name: "getDocumentTypes",
    type: "query",
    serviceFn: ({ documentType }: { documentType: string }) =>
      dashboardService.getDocumentTypes(documentType),
  },
  {
    name: "getTrainingVideos",
    type: "query",
    serviceFn: () => dashboardService.getTrainingVideo(),
  },
] as const;

export const organizationMasterApi = rootApi.injectEndpoints({
  endpoints: (builder) => makeEndpoints(builder, organizationMasterEndpoints),
});

export const {
  useGetCentersListQuery,
  useGetDepartmentListQuery,
  useGetDocumentTypesQuery,
  useGetTrainingVideosQuery,
  useGetSubDepartmentListQuery,
  useGetMisDownloadDetailsQuery,
  useGetEmployeeJobTypesListQuery,
  useGetEmployeeRolesTypeListQuery,
} = organizationMasterApi;
